import React, {useEffect, useState} from 'react'
import OrderStep from "./OrderStep";
import {Container, Form, Loader, Dimmer, Modal, Button, Icon} from 'semantic-ui-react';
import OrderInvoiceDetail from "./OrderInvoiceDetail";
import OrderPaymentDetail from "./OrderPaymentDetail";
import OrderSummary from "./OrderSummary";
import OrderResult from "./OrderResult";

import {API_BASE} from "../config/env";

import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import PropTypes from "prop-types";
import Helper from "./Helper";


function Order(props){

    Order.propTypes = {
        closeModal: PropTypes.func,
        invoice: PropTypes.object.isRequired,
        callerMsisdn : PropTypes.object.isRequired
    };

    const [step, setStep] = useState(1);
    const [selectedCard, setSelectedCard] = useState('');
    const [validated, setValidated] = useState(false);
    const [savedCardList, setSavedCardList] = useState([]);
    const [operationResult, setOperationResult] = useState();
    const [saveOrderProcessActive, setSaveOrderProcessActive] = useState(false);
    const [informationModalOpen, setInformationModalOpen] = useState(false);
    const {getTrackingId} = Helper();


    useEffect(() => {
        setInformationModalOpen(true);
    }, [])

    const next = () => {
        setStep(step + 1);
    }

    const prev = () => {
       setStep(step - 1)
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        //just show the success page (step 4 )
        setStep(4);
    }

    const changeValidatedStatus = (status) => {
        setValidated(status);
    }

    const selectPaymentMethod = (card) => {
        setSelectedCard(card);
    }

    const saveOrderPayment = async (e,recordName) => {
        setSaveOrderProcessActive(true);
        e.preventDefault();
        const result = await saveOrderPay(props.callerMsisdn,props.invoice.corpCode,selectedCard.paymentMethodID,recordName,
            props.invoice.subscriberNo,props.invoice.subscriberNo2,false);
        if (result){
            setOperationResult(result.operationResult);
        } else{
            const operationResult = {
                resultCode: '-1',
                resultDesc:'Lütfen Tekrar Deneyiniz.'
            }
            setOperationResult(operationResult)
        }
        setSaveOrderProcessActive(false);
        next();
    };

    const saveOrderPay = async (msisdn,corpCode, paymentMethodId, recordName, subscriberNo1, subscriberNo2, isDonation) => {
        let databody = {
            msisdn: msisdn,
            corpCode: corpCode,
            paymentMethodId: paymentMethodId,
            recordName: recordName,
            subscriberNo1: subscriberNo1,
            subscriberNo2: subscriberNo2,
            isDonation: isDonation,
            trackingId:getTrackingId()
        };

        try {
            const response = await axios.post(`${API_BASE}/saveOrderPayment`, databody)
                .catch((error) => console.log(error));
            if (response.status === 200) {
                //props.changeServiceMessage(response.data.operationResult.resultDesc);
                //props.changeMessageOpen(true);
                return response.data;
            }
        } catch (err) {
            console.error(err);
            return false;
        }
    };

    const Step = ({ step, next, prev }) => {
        switch (step) {
            case 1:
                return <OrderInvoiceDetail next={next} close={props.closeModal} invoice={props.invoice}/>
            case 2:
                return <OrderPaymentDetail next={next} prev={prev} close={props.closeModal} invoice={props.invoice}
                                           msisdn={props.callerMsisdn} changeValidatedStatus={changeValidatedStatus}
                                           selectPaymentMethod={selectPaymentMethod}/>
            case 3:
                return <OrderSummary  next={next} prev={prev} close={props.closeModal} invoice={props.invoice}
                                      selectedCard={selectedCard} saveOrderPayment={saveOrderPayment} />
            case 4:
                return <OrderResult next={next} prev={prev} invoice={props.invoice} operationResult={operationResult} closeModal={props.closeModal}/>
            default:
                return null;
        }
    }

    return (
    <Container>
        <Form onSubmit={handleSubmit}>
            <Dimmer active={saveOrderProcessActive} inverted>
                <Loader inverted>Ödeme Talimatı Kaydediliyor...</Loader>
            </Dimmer>
            <Modal
                closeOnDimmerClick={false}
                open={informationModalOpen}
                onClose={() => setInformationModalOpen(false)}
                onOpen={() => setInformationModalOpen(true)}
                id='info-modal'
                size={'mini'}
            >
                <Modal.Header>
                    Bilgilendirme
                </Modal.Header>
                <Modal.Content>
                    Fatura ödeme talimatı verebilmek için
                    <a target='_blank' href='https://paycell.com.tr/app-redirect'> Paycell </a>
                    müşterisi olmanız gerekmektedir. Paycell müşterisi olmak için
                    <a target='_blank' href='https://paycell.com.tr/app-redirect'> linke </a>
                     tıklayarak kaydınızı kolayca yapabilirsiniz.
                </Modal.Content>
                <Modal.Actions >
                    <Button onClick={() => setInformationModalOpen(false)}>
                        Devam
                    </Button>
                </Modal.Actions>
            </Modal>
            <OrderStep step={step}/>
            <Step step={step} next={next} prev={prev}
                  changeValidatedStatus={changeValidatedStatus} selectPaymentMethod={selectPaymentMethod} selectedCard={selectedCard}
                  saveOrderPayment={saveOrderPayment} invoice={props.invoice} operationResult={operationResult}/>
        </Form>
    </Container>
    )


}

export default Order;